import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { RedirectUrls } from 'src/types/types'
import { HygraphTopics } from 'src/utils/hygraph'

type Category = {
  id: string
  name: string
  path: string
}

type Props = {
  categories: Category[]
  selectedCategory: HygraphTopics | null
}

const CategorySection = ({ categories, selectedCategory }: Props) => {
  const { t } = useTranslation('blog')

  const linkClass = (isActive: boolean) =>
    `relative pb-3 text-[12px] tracking-[0.16em] uppercase transition-colors duration-200 md:text-[13px] ${
      isActive ? 'text-ink-700' : 'text-ink-200 hover:text-ink-700'
    }`

  const underline = (isActive: boolean) =>
    `pointer-events-none absolute inset-x-0 -bottom-px h-px transition-colors duration-200 ${
      isActive ? 'bg-blue-500' : 'bg-transparent'
    }`

  return (
    <nav
      aria-label={t('CATEGORY.FILTER_LABEL')}
      className="border-y border-ink-100/15 py-5 md:py-6"
    >
      <div className="-mx-5 overflow-x-auto px-5 md:mx-0 md:overflow-visible md:px-0">
        <ul className="flex min-w-max items-center gap-x-7 gap-y-3 md:flex-wrap md:gap-x-9">
          <li>
            <Link
              href={RedirectUrls.Blog}
              className={linkClass(!selectedCategory)}
            >
              {t('CATEGORY.ALL')}
              <span
                aria-hidden="true"
                className={underline(!selectedCategory)}
              />
            </Link>
          </li>
          {categories.map((category) => {
            const isActive = selectedCategory === category.id
            return (
              <li key={category.id}>
                <Link href={category.path} className={linkClass(isActive)}>
                  {category.name}
                  <span aria-hidden="true" className={underline(isActive)} />
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    </nav>
  )
}

export default CategorySection
